<template><svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="2" height="10" fill="currentColor"/>
    <rect x="5" width="2" height="10" fill="currentColor"/>
    <rect x="10" width="2" height="10" fill="currentColor"/>
</svg>
</template>